
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form-approval",
      function () {
        return require("private-next-pages/form-approval/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form-approval"])
      });
    }
  